// import TractorGif from '@assets/tractor.gif';

// export const GeneralLoader = () => {
// 	return (
// 		<div className="flex justify-center items-center w-full h-full">
// 			<img src={TractorGif} alt="Tractor" className="w-[512px]" />
// 		</div>
// 	);
// };

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

export function GeneralLoader() {
	return (
		<Box display="flex" justifyContent="center" alignItems="center" height="100vh">
			<CircularProgress style={{ color: '#038877' }} />
		</Box>
	);
}
